/** PRODUCTION **/
export const SERVICE_PREFIX = "http://api.alacuenta.com:25102";

export const URLS = [
  {
    "path": "/zona1",
    "navigateTo": "/antioquia/envigado/el-chingui"
  },
  {
    "path": "/bosa",
    "navigateTo": "/cundinamarca/bogota/bosa"
  },
  {
    "path": "/loma-de-las-brujas",
    "navigateTo": "/antioquia/envigado/loma-de-las-brujas"
  },
  {
    "path": "/loma-del-escobero",
    "navigateTo": "/antioquia/envigado/loma-del-escobero"
  },
  {
    "path": "/la-pradera",
    "navigateTo": "/antioquia/envigado/la-pradera"
  },
  {
    "path": "/el-chingui",
    "navigateTo": "/antioquia/envigado/el-chingui"
  },
  {
    "path": "/el-salado",
    "navigateTo": "/antioquia/envigado/el-salado"
  },
  {
    "path": "/san-jose",
    "navigateTo": "/antioquia/envigado/san-jose"
  }
];
